// extracted by mini-css-extract-plugin
module.exports = {"container":"RegisterView_container__1pK66","modal":"RegisterView_modal__Oc4d5","qrLabel":"RegisterView_qrLabel__1Gvpy","signIn":"RegisterView_signIn__1lxmE"};